import { I18n } from "@assets/strings";
import React from "react";
import { useHistory } from "@core/routing/useHistory";
import styled from "styled-components";
import { Path } from "@core/routing/path";
import { Group } from "@domain/group/group";
import { PrimaryButton } from "@ui/components/buttons/primaryButton";
import { Primary } from "@ui/components/containers/primary";
import { row } from "@ui/components/layout";
import { ClosableModal } from "@ui/modals/closableModal";
interface CashoutTreatmentModalProps extends React.HTMLAttributes<HTMLDivElement> {
	close: () => void;
	shareroom: Group;
}

export const CashoutTreatment: React.FC<CashoutTreatmentModalProps> = ({ shareroom, close, ...htmlProps }) => {
	const history = useHistory();
	const closeModal = (): void => {
		history.push(Path.Shareroom(shareroom));
		close();
	};
	return (
		<Container
			close={() => {
				history.push(Path.Shareroom(shareroom));
				close();
			}}
			{...htmlProps}
		>
			<ContainerLabel>
				<Primary>
					<StuledLabelText>
						<b>{I18n.t("shareroom.operation.progress.title")}</b>
					</StuledLabelText>
				</Primary>
			</ContainerLabel>
			<Info>{I18n.t("shareroom.operation.progress.description")}</Info>
			<BlocButton>
				<StyledButtonContainer onClick={closeModal}>Ok</StyledButtonContainer>
			</BlocButton>
		</Container>
	);
};

const Container = styled(ClosableModal)`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
`;

const ContainerLabel = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
`;

const Info = styled.div`
	${row(16, "flex-start", "baseline")};
	${({ theme }) => theme.textStyles.description};
	font-style: normal;
	font-weight: 400;
	font-size: 15px;
	line-height: 30px;
	text-align: center;
	color: #000000;
	margin-top: 30px;
`;

const StuledLabelText = styled.div`
	font-style: normal;
	font-size: 24px;
	margin-top: 16px;
`;
const BlocButton = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	margin-top: 30px;
`;
const StyledButtonContainer = styled(PrimaryButton)``;
